import React from 'react'
import './Licenses.css'

const Licenses = ({ transporter_data }) => {
    const license = transporter_data?.license

    if (license?.fssai !== 'yes') {
        return (
            <div>
                <h3 className="data_header">Licenses/Certifications</h3>
                <div className="overflow-auto pb-2">Details not available</div>
            </div>
        )
    }

    const categories = [
        license.cat_4 === 'yes' ? 'CAT 4' : null,
        license.cat_5 === 'yes' ? 'CAT 5' : null,
        license.cat_9 === 'yes' ? 'CAT 9' : null,
    ].filter(Boolean).join(', ')

    return (
        <div>
            <h3 className="data_header">Licenses/Certifications</h3>
            <div className="overflow-auto pb-2">
                <div>
                    <div>FSSAI{categories ? ` - ${categories}` : ''}</div>
                </div>
            </div>
        </div>
    )
}

export default Licenses
